import React from 'react';
import {
  FormLabel,
  FormControl,
  FormErrorMessage,
  Checkbox,
} from '@chakra-ui/react';

export const CheckboxControl = (props: any): JSX.Element => {
  const {
    name,
    errors,
    isInvalid = false,
    errorMessage,
    isRequired = false,
    onChange = () => {},
    ...rest
  } = props;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.checked);
  }

  return (
    <FormControl pt={2} isInvalid={isInvalid} isRequired={isRequired}>
      <Checkbox color="gray.700" name={name} onChange={handleChange}>
        <FormLabel mb={0} fontSize="sm">{rest.children}</FormLabel>
      </Checkbox>
      <FormErrorMessage>{errorMessage}</FormErrorMessage>
    </FormControl>
  );
}
